import { useCallback, useState } from 'react';
import { UseDragAndDropFilesParams, UseDragAndDropFilesReturn } from './types';

const useDragAndDropFiles = ({ handleFiles }: UseDragAndDropFilesParams): UseDragAndDropFilesReturn => {
  const [isOver, setIsOver] = useState(false);

  const preventDefault = useCallback((event: React.DragEvent | React.ChangeEvent) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const handleDragOverOrEnter = useCallback(
    (event: React.DragEvent) => {
      preventDefault(event);
      setIsOver(true);
    },
    [preventDefault]
  );

  const handleOnDrop = useCallback(
    (event: React.DragEvent) => {
      setIsOver(false);
      preventDefault(event);
      const { files } = event.dataTransfer;
      if (files.length) {
        handleFiles(files);
      }
    },
    [preventDefault, handleFiles]
  );

  const handleDragLeave = useCallback(
    (event: React.DragEvent) => {
      preventDefault(event);
      setIsOver(false);
    },
    [preventDefault]
  );

  return { isOver, handleDragOverOrEnter, handleOnDrop, handleDragLeave };
};

export default useDragAndDropFiles;
